import { CaseUpdatePresetModel } from './caseUpdatePresetModel';

export class AddCaseUpdatePresetModel extends CaseUpdatePresetModel{
}
